<template>
  <div :class="['view', { view2: classActive }]">
    <div class="header-nav-container">
      <div class="row-between header-nav-list">
        <div class="row">
          <img
            src="../assets/images/icon_contact.png"
            style="width: 19px; height: 19px; margin-right: 6px"
          />
          <p>{{ $t("Hotline:021-32513000") }}</p>
        </div>
        <div class="row">
          <div class="row" style="cursor: pointer">
            <img
              v-if="activeLanguage == 'English'"
              src="../assets/images/icon_lan_en.png"
              style="width: 19px; height: 19px"
            />
            <img
              v-if="activeLanguage == '中文'"
              src="../assets/images/icon_lan_zh.png"
              style="width: 19px; height: 19px"
            />
            <el-dropdown @command="handleCommand">
              <span class="el-dropdown-link">
                {{ activeLanguage
                }}<i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item
                  v-for="(item, idx) in languageList"
                  :key="idx"
                  :command="item.id"
                  >{{ item.info }}</el-dropdown-item
                >
              </el-dropdown-menu>
            </el-dropdown>
          </div>
          <!-- <div
            class="row ml26"
            @click="handleGoWorkbench"
            v-if="
              hasAuthentication()
                ? !exhibitor || (!!exhibitor && !exhibitor.id)
                : true
            "
            style="cursor: pointer"
            :class="{
              disabled: hasAuthentication()
                ? !exhibitor || (!!exhibitor && !exhibitor.id)
                : true
            }"
          >
            <img
              src="../assets/images/icon_buyer.png"
              style="width: 19px; height: 19px; margin-right: 6px;"
            />
            <p>{{ $t("For Buyers2") }}</p>
          </div> -->
          <!-- <div
            class="row ml26"
            @click="handleGoWorkbench"
            v-if="hasAuthentication() ? !!exhibitor && !!exhibitor.id : true"
            style="cursor: pointer"
            :class="{
              disabled: hasAuthentication()
                ? !exhibitor || (!!exhibitor && !exhibitor.id)
                : true
            }"
          >
            <img
              src="../assets/images/icon_seller.png"
              style="width: 19px; height: 19px; margin-right: 6px"
            />
            <p>{{ $t("For Suppliers") }}</p>
          </div> -->
          <div
            class="row ml26"
            @click="handleCollectedClick"
            style="cursor: pointer"
            :class="{
              disabled: hasAuthentication()
                ? !exhibitor || (!!exhibitor && !exhibitor.id)
                : true,
            }"
          >
            <img
              src="../assets/images/icon_save.png"
              style="width: 19px; height: 19px; margin-right: 6px"
            />
            <p>{{ $t("Favorites") }}</p>
          </div>
          <div
            v-if="showMessageEntry"
            class="row ml26"
            @click="handleClickMessage"
            style="cursor: pointer"
            :class="{
              disabled: hasAuthentication()
                ? !exhibitor || (!!exhibitor && !exhibitor.id)
                : true,
            }"
          >
            <img
              src="../assets/images/icon_leave.png"
              style="width: 19px; height: 19px; margin-right: 6px"
            />
            <p>{{ $t("Massage") }}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="header-func-container row">
      <div class="header-func-list row-between">
        <div class="row">
          <img
            src="../assets/images/header_logo.png"
            style="
              width: 228px;
              height: 52px;
              margin-right: 36px;
              cursor: pointer;
            "
            @click="() => $router.push('/')"
          />
          <div class="row-between search-box">
            <el-input
              :placeholder="$t('Search company or product or news…')"
              style="width: 500px; border: 1px solid #619a37"
              v-model="queryContent"
              class="input-with-select"
            >
              <el-select
                v-model="queryKey"
                style="width: 80px; border: unset"
                slot="prepend"
                placeholder="请选择"
                :style="
                  $i18n.locale == 'zh' ? '' : 'width:110px; border: unset'
                "
              >
                <el-option :label="$t('exhibit')" value="exhibit"></el-option>
                <el-option
                  :label="$t('business1')"
                  value="business"
                ></el-option>
                <el-option :label="$t('artilce1')" value="article"></el-option>
              </el-select>
              <el-button
                style="
                  color: #fff;
                  border: unset;
                  background: #619a37;
                  border-radius: unset;
                  height: 40px;
                "
                @click="goPageWithKey"
                slot="append"
                icon="el-icon-search"
                >{{ $t("Search") }}</el-button
              >
            </el-input>
          </div>
          <!-- <div class="row-between search-box">
            <div>
              <i
                class="el-icon-search"
                style="color: #999; margin-left: 14px"
              ></i>
              <input
                class="search-box-input"
                :placeholder="$t('Search company or product or news…')"
              />
            </div>
            <p class="search-box-text">{{ $t("Search") }}</p>
          </div> -->
        </div>
        <div class="row">
          <div class="apply" @click="toApplication">
            {{ $t("Application") }}
          </div>
          <div class="column-center qrcode-box">
            <img
              src="../assets/images/icon_qrcode.png"
              style="width: 68px; height: 68px"
            />
            <p>{{ $t("Scan this") }}</p>
          </div>
          <div
            class="row-center pub-box"
            @click="handleClickPublishPurchaseMessage"
          >
            <img
              src="../assets/images/icon_pub.png"
              style="width: 27px; height: 27px; margin-right: 8px"
            />
            <p :style="$i18n.locale == 'zh' ? '' : 'font-size: 12px;'">
              {{ $t("Publish Transaction") }}
            </p>
          </div>
        </div>
      </div>
    </div>
    <div
      id="searchBar"
      :class="['content-container row', { isFixed: searchBarFixed }]"
    >
      <div class="content row-between">
        <div class="pages_info">
          <span
            @click="toggle(idx, item)"
            :class="{ active: idx == checkedIdx }"
            v-for="(item, idx) in pageList"
            :key="idx"
          >
            <template v-if="idx == 0">
              <img
                src="../assets/images/icon_home.png"
                style="
                  width: 17px;
                  height: 17px;
                  margin-right: 6px;
                  position: relative;
                  top: 3px;
                "
              />
              {{ $t(item.nav) }}
            </template>
            <template v-else>{{ $t(item.nav) }}</template>
          </span>
        </div>
        <div
          class="console row-around"
          style="
            box-sizing: border-box;
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 0 8px;
          "
          v-if="user.id"
          @click="handleGoWorkbench"
        >
          <!-- <div v-if="type == 'EXHIBITOR'">展商</div>
          <div v-if="type == 'VISITOR'">观众</div> -->
          <img
            src="../assets/images/icon_login.png"
            style="width: 20px; height: 20px"
          />
          <!-- <div
            style="font-size: 6px; line-height:15px; max-width: 100px; cursor: pointer;"
          >
            {{ $t("console") }}
          </div> -->
          <!-- :style="
              user.username.length > 6
                ? 'font-size: 6px; line-height:15px; max-width: 100px; cursor: pointer;'
                : 'max-width: 100px;  cursor: pointer;'
            " -->
          <div class="hover-box-outer">
            <div
              class="hover-box"
              :class="{
                'hover-box-disable': hasAuthentication()
                  ? !exhibitor || (!!exhibitor && !exhibitor.id)
                  : true,
              }"
            >
              <div class="before-hover">
                <div
                  class="a"
                  :style="{
                    cursor: (
                      hasAuthentication()
                        ? !exhibitor || (!!exhibitor && !exhibitor.id)
                        : true
                    )
                      ? 'default'
                      : 'pointer',
                  }"
                >
                  {{ user.name || user.username }}
                </div>
              </div>
              <div
                class="after-hover"
                v-if="
                  !(hasAuthentication()
                    ? !exhibitor || (!!exhibitor && !exhibitor.id)
                    : true)
                "
              >
                {{ $t("console") }}
              </div>
            </div>
          </div>
          <div style="cursor: pointer; flex-shrink: 0" @click.prevent="logout">
            {{ $t("Exit") }}
          </div>
        </div>
        <div
          @click="toLogin"
          class="console"
          v-else
          style="
            cursor: pointer;
            display: flex;
            justify-content: center;
            align-items: center;
          "
        >
          <img
            src="../assets/images/icon_login.png"
            style="width: 20px; height: 20px"
          />
          <div
            class="router"
            :style="{
              fontSize: $i18n.locale == 'zh' ? '18px' : '15px',
            }"
          >
            {{ $t("signInMajuscule") }}
          </div>
          <!--<router-link to="/login">{{ $t("signInMajuscule") }} </router-link>-->
          <!-- <router-link to="/register">{{
            $t("joinFreeMajuscule")
          }}</router-link> -->
        </div>
      </div>
    </div>
    <Supplydialog
      v-if="dialogFormVisible"
      :key="dialogFormVisible"
      :dialogFormVisible="dialogFormVisible"
      @handleCloseDialog="(is) => (dialogFormVisible = is)"
    />
    <Dialoglist
      v-if="dialogMessageFormVisible"
      :key="dialogMessageFormVisible"
      :dialogtype="'contactmain'"
      :dialogFormVisible="dialogMessageFormVisible"
      @handleCloseDialog="(is) => (dialogMessageFormVisible = is)"
    />
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";

import { EventBus } from "@/EventBus.js";
import Supplydialog from "@/components/supplydialog";
import Dialoglist from "@/components/dialoglist";

export default {
  components: {
    Supplydialog,
    Dialoglist,
  },
  data() {
    const lang =
      this.$route.query.lang || localStorage.getItem("language") || "zh";
    this.$i18n.locale = lang;
    return {
      // 页面列表
      pageList: [
        { nav: "HOMEPAGE" },
        { nav: "PRODUCT" },
        { nav: "COMPANY" },
        // { nav: "MEETING" },
        { nav: "INFORMATION" },
        // { nav: "CONTRACT" },
        { nav: "EXHIBITOR" },
      ],
      // 默认页面
      checkedIdx: 0,
      // 语音列表
      languageList: [
        {
          id: "zh",
          info: this.$t("zh"),
        },
        {
          id: "en",
          info: this.$t("en"),
        },
      ],
      // 默认中文
      activeLanguage: this.$t(lang),
      classActive: false,
      dialogFormVisible: false,
      dialogMessageFormVisible: false,
      showMessageEntry: false,
      type: localStorage.getItem("type"),
      searchBarFixed: false,
      queryKey: "exhibit",
      queryContent: "",
    };
  },
  computed: {
    ...mapState({
      exhibitor: (state) => state.exhibitor,
      user: (state) => state.user,
    }),
    ...mapGetters({
      hasAuthentication: "hasAuthentication",
    }),
  },
  methods: {
    ...mapActions({
      deleteAuthentication: "deleteAuthentication",
    }),
    toApplication() {
      const url = process.env.VUE_APP_APPLICATION_URL;
      window.open(url);
    },
    goPageWithKey() {
      switch (this.queryKey) {
        case "exhibit":
          this.$router.push({
            name: "onlineshow",
            query: {
              key: this.queryContent,
            },
          });
          break;
        case "business":
          this.$router.push({
            name: "business",
            query: {
              key: this.queryContent,
            },
          });
          break;
        case "article":
          this.$router.push({
            name: "viewsmore",
            query: {
              key: this.queryContent,
            },
          });
          break;
        default:
          break;
      }
    },
    goHome() {
      if (this.checkedIdx != 0) {
        this.$router.push("/");
        this.checkedIdx = 0;
      }
    },
    logout() {
      this.deleteAuthentication();
      const lang = localStorage.getItem("language");
      localStorage.clear();
      localStorage.setItem("language", lang);
      this.type = "";
    },
    handleCloseDialog(is) {
      this.dialogFormVisible = is;
    },
    // 切换页面
    toggle(idx, { nav }) {
      switch (nav) {
        // case this.checkedIdx:
        //   break;
        case "HOMEPAGE":
          this.$router.push("/");
          break;
        case "PRODUCT":
          this.$router.push("/onlineshow");
          break;
        case "COMPANY":
          this.$router.push("/business");
          break;
        case "MEETING":
          this.$router.push("/meetings");
          break;
        case "INFORMATION":
          this.$router.push("/article");
          break;
        case "CONTRACT":
          this.$router.push("/document/5");
          break;
        case "EXHIBITOR": {
          const query =
            sessionStorage.getItem("exhibitorsYear") === "2025"
              ? { year: "2025" }
              : undefined;
          this.$router.push({ path: "/exhibitors", query });
          break;
        }

        default:
          this.$router.push("/");
          break;
      }
      this.checkedIdx = idx;
    },
    // 下拉框选择语言
    handleCommand(command) {
      console.log(command, "command");
      localStorage.setItem("language", command);
      const { ...query } = this.$route.query;
      this.$router.replace({
        query: {
          ...query,
          lang: command,
        },
      });
      switch (command) {
        case "zh":
          this.activeLanguage = this.$t("zh");
          break;
        case "en":
          this.activeLanguage = this.$t("en");
          break;

        default:
          this.activeLanguage = this.$t("zh");
          break;
      }
      this.$i18n.locale = command;
      EventBus.$emit("localeChange");
    },
    handleScroll() {
      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      var offsetTop = document.querySelector("#searchBar").offsetTop;
      if (scrollTop > offsetTop) {
        this.searchBarFixed = true;
      } else {
        this.searchBarFixed = false;
      }
    },
    handleClickPublishPurchaseMessage() {
      if (!this.hasAuthentication()) {
        this.$router.push("/login");
        return;
      }

      this.dialogFormVisible = true;
    },
    handleClickMessage() {
      if (!this.hasAuthentication()) {
        this.$router.push("/login");
        return;
      }

      this.dialogMessageFormVisible = true;
    },
    handleGoWorkbench() {
      if (
        this.hasAuthentication()
          ? !this.exhibitor || (!!this.exhibitor && !this.exhibitor.id)
          : true
      ) {
        return;
      }
      if (!this.hasAuthentication()) {
        this.$router.push("/login");
        return;
      }

      const token = localStorage.getItem("token");
      window.open(
        `${process.env.VUE_APP_EXHIBITOR_MANAGE_URL}?from=forestage&token=${token}&platform=pc`,
        "_blank"
      );
      // window.location.href =`${process.env.VUE_APP_EXHIBITOR_MANAGE_URL}?from=forestage&token=${token}&platform=pc`
    },
    handleCollectedClick() {
      if (!this.hasAuthentication()) {
        this.$router.push("/login");
        return;
      }

      window.location.href = "https://workbench.e-chinacycle.com/#/collection";
    },
    toLogin() {
      this.$router.push({
        name: "login",
        query: { identity: "exhibitor" },
      });
    },
  },
  watch: {
    checkedIdx(val) {
      console.log(val);
      if (val == 0) {
        this.classActive = false;
      } else {
        this.classActive = true;
      }
    },
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  created() {
    EventBus.$on("switchTab", (index) => {
      console.log(index, "switchTab on");
      this.checkedIdx = index;
    });
    let key = this.$route.path;
    const map = {
      "/": "HOMEPAGE",
      "/onlineshow": "PRODUCT",
      "/business": "COMPANY",
      "/meetings": "MEETING",
      "/article": "INFORMATION",
      "/document/5": "CONTRACT",
      "/exhibitors": "EXHIBITOR",
    };
    this.checkedIdx = this.pageList.findIndex((item) => {
      return item.nav == map[key];
    });
    // switch (key) {
    //   case "/":
    //     this.checkedIdx = 0;
    //     break;
    //   case "/onlineshow":
    //     this.checkedIdx = 1;
    //     break;
    //   case "/business":
    //     this.checkedIdx = 2;
    //     break;
    //   case "/article":
    //     this.checkedIdx = 3;
    //     break;
    //   case "/document/5":
    //     this.checkedIdx = 4;
    //     break;

    //   default:
    //     this.checkedIdx = 0;
    //     break;
    // }
  },
};
import "../assets/less/index.css";
</script>
<style lang="less" scoped>
// .a {
//   float: left;
//   overflow: hidden;
//   text-overflow: ellipsis;
//   white-space: nowrap;
//   width: 300px;
//   // background-color: red;
// }
.isFixed {
  position: fixed;
  background-color: #fff;
  top: 0;
  z-index: 1500;
  left: 0;
  right: 0;
}
.view {
  width: 100%;
  height: 194px;
  line-height: 41px;
  color: #fff;
  // position: absolute;
  top: 0;
  z-index: 3;
  min-width: 750px;
  // position: fixed;
  // top: 0;
}
.view2 {
  // background-color: rgba(255, 255, 255, 0.4);
  // box-shadow: 0 1px 3px 0 hsla(0, 0%, 80%, 0.5);
  color: #fff;
  // position: absolute;
  top: 0;
  z-index: 3;
  a {
    // color: #2c3e50 !important;
  }
  .el-dropdown-link {
    color: #2c3e50;
  }
}
.content {
  width: 1200px;
  margin: 0 auto;
  height: 50px;
  .pages_info {
    height: 50px;
    line-height: 50px;
    span {
      display: inline-block;
      padding: 0 25px;
      cursor: pointer;
      // font-size: 14px;
      &:hover {
        background: #619a37;
      }
    }
    .active {
      background: #619a37;
      color: #ffffff;
      height: 50px;
    }
  }
  .console {
    background: #4f4f4f;
    height: 50px;
    line-height: 50px;
    font-size: 14px;
    width: 170px;
    img {
      width: 40px;
      height: 40px;
      border-radius: 50px;
      vertical-align: middle;
      margin-right: 10px;
    }
    .a {
      color: #ff9800;
      float: left;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      width: 100px;
      cursor: pointer;
    }

    .hover-box-outer {
      width: 100px;
      height: 50px;
      overflow: hidden;
      .hover-box {
        position: relative;
        height: 100%;
        width: 200%;
        display: flex;
        .before-hover {
          width: 50%;
          height: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
          color: #ff9800;
          float: left;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .after-hover {
          width: 50%;
          height: 100%;
          color: #ff9800;
          text-align: center;
          cursor: pointer;
          display: flex;
          justify-content: center;
          align-items: center;
        }
      }
      .hover-box:not(.hover-box-disable):hover {
        transform: translate(-50%, 0);
      }
    }
  }
}
.el-dropdown-link {
  cursor: pointer;
  color: #444;
  margin-left: 10px;
  font-size: 12px;
  font-weight: 500;
}
.el-icon-arrow-down {
  font-size: 14px;
}
.ml26 {
  margin-left: 26px;
  p {
    font-weight: 500;
  }
}
.header-nav-list,
.header-func-list {
  width: 1200px;
  display: flex;
  align-items: center;
  align-self: center;
  margin: 0 auto;
  // text-align: center;

  font-size: 14px;
  font-family: FZLanTingHei-R-GBK;
  font-weight: 400;
  color: #444444;
}
.header-nav-container,
.header-func-container {
  background: #eeeeee;
}
.header-nav-container {
}
.header-func-container {
  border-top: 1px solid #ddd;
  height: 103px;
}
.content-container {
  background: #373737;
  height: 50px;
}
.header-func-list {
}
.header-nav-list p {
  color: #444444;
  font-size: 12px;
  font-weight: bolder;
}
/deep/ .el-input-group__append,
.el-input-group__prepend {
  border: unset;
}
.search-box {
  border: 1px solid #619a37;
  // box-shadow: 0px 0px 7px 0px rgba(0, 0, 0, 0.2);
  // width: 430px;
}
.search-box-input {
  border: unset;
  background: unset;
  border-left: 1px solid #ddd;
  width: 240px;
  padding: 0 10px;
  margin: 10px 0;
}
input {
  outline: none;
}
.search-box-text {
  width: 92px;
  text-align: center;
  background: #619a37;
  font-size: 14px;

  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
}
.qrcode-box {
  width: 68px;
  margin-right: 18px;
  img {
  }
  p {
    font-size: 12px;
    font-family: FZLanTingHeiS-DB1-GBK;
    font-weight: 400;
    color: #444444;
    line-height: 20px;
  }
}
.pub-box {
  width: 170px;
  height: 103px;
  background: #619a37;
  cursor: pointer;
  img {
  }
  p {
    font-size: 18px;
    font-family: FZLanTingHeiS-DB1-GBK;
    font-weight: 400;
    color: #ffffff;
  }
}

.router {
  color: #ff9800;
  font-size: 18px;
}
.isEN {
  font-size: 16px;
}

.disabled {
  cursor: not-allowed;
  pointer-events: none;
  opacity: 0.3;
}

.apply {
  width: 100px;
  line-height: 40px;
  background: rgba(97, 154, 55, 1);
  color: #fff;
  text-align: center;
  font-size: 12px;
  font-family: FZLanTingHeiS-DB1-GBK;
  font-weight: 400;
  margin-right: 18px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/header.vue